import React, { createContext, useContext, useMemo } from 'react';
import { INTERFACE_THEME, UA_THEME_VARS } from '@unifyapps/style/themes/consts';
import { StyleOverride } from '../../styles/StyleOverride';
import type { ColorScheme } from '../../types/index';

type ThemeOverrideContextType = {
  themeOverrideClassName: string;
  /**
   * Scheme to be applied to the theme override
   */
  scheme?: 'light' | 'dark' | 'system';
};

const ThemeOverrideContext = createContext<ThemeOverrideContextType>({
  themeOverrideClassName: '',
  scheme: undefined,
});

export function useThemeOverrideContext() {
  return useContext(ThemeOverrideContext);
}

type ThemeOverrideProviderProps = {
  style: string | undefined;
  scheme?: ColorScheme;
  children: React.ReactNode;
};

/**
 * Provides theme override provider for Interface Builder and Preview
 *
 */
export function ThemeOverrideContextProvider({
  style,
  scheme,
  children,
}: ThemeOverrideProviderProps) {
  const themeOverrideClassName = style ? `${UA_THEME_VARS} ${INTERFACE_THEME}` : '';

  const contextValue = useMemo(
    () => ({ themeOverrideClassName, scheme }),
    [themeOverrideClassName, scheme],
  );

  return (
    <ThemeOverrideContext.Provider value={contextValue}>
      {style ? <StyleOverride style={style} /> : null}
      {children}
    </ThemeOverrideContext.Provider>
  );
}
